/**
 * Sequential bulk delete with per-id result text; shared pattern for finance list pages.
 * @param {string[]} ids
 * @param {(id: string) => Promise<{ ok: boolean, body: string }>} deleteOne
 * @param {(err: unknown) => string} getMessageForFetchError
 */
export async function bulkSequentialDelete(ids, deleteOne, getMessageForFetchError) {
  let successCount = 0;
  let errorCount = 0;
  const errors = [];
  for (let i = 0; i < ids.length; i++) {
    const id = ids[i];
    try {
      const { ok, body } = await deleteOne(id);
      if (ok) successCount++;
      else {
        errorCount++;
        errors.push(`ID ${id}: ${body}`);
      }
    } catch (error) {
      errorCount++;
      errors.push(`ID ${id}: ${getMessageForFetchError(error)}`);
    }
  }
  return { successCount, errorCount, errors };
}
